import { render, staticRenderFns } from "./DisposalOrdersEdit.vue?vue&type=template&id=cda772a4&scoped=true"
import script from "./DisposalOrdersEdit.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda772a4",
  null
  
)

export default component.exports